import Vue from 'vue';
import VueLazyload from 'vue-lazyload';
import App from './App.vue';
import router from './router';
import store from './store';
import './plugins/element';
import './assets/styles/public.css';
import './plugins/flexible';

Vue.config.productionTip = false;

Vue.use(VueLazyload);

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'));
  },
}).$mount('#app');
